import { graphql, useStaticQuery } from 'gatsby'

import { Nodes } from '@src/types/graphql'
import { NewsArticle } from '@src/types/news'

export default function useNewsArticles() {
  const result = useStaticQuery<{
    newsArticles: Nodes<NewsArticle>
  }>(graphql`
    query {
      newsArticles: allSanityNewsForYou(filter: { active: { eq: true } }) {
        nodes {
          enHref
          frHref
          id
          photo {
            asset {
              url
            }
          }
          link {
            en
            fr
          }
          title {
            en
            fr
          }
          description {
            en
            fr
          }
          order
        }
      }
    }
  `)

  return result.newsArticles.nodes.sort((a, b) => a.order - b.order) as NewsArticle[]
}
